import {Map, List} from 'immutable';
import {GET, POST, PUT} from '../methods';

export function split(data) {
  const representations = Map().asMutable();
  const resources = Map().asMutable();

  Object.keys(data).map((key) => {
    data[key].map((datum) => {
      representations.setIn([key, datum.id.toString()], datum);
      if (!resources.has(key)) {
        resources.set(key, List());
      }
      resources.update(key, (typeList) => {
        return typeList.push(datum.id.toString());
      });
    });
  });

  return {
    representations: representations.asImmutable(),
    resources: resources.asImmutable(),
  };
}

export function updateRepresentations(prev, next, request) {
  let retval = prev;

  if (~[GET, POST, PUT].indexOf(request.method)) {
    retval = prev.mergeDeep(next);
  }

  return retval;
}



// WEBPACK FOOTER //
// ./app/javascript/requests/reducers/utils.js